import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomFacade, SharedFacade } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { LabelType, Options } from '@angular-slider/ngx-slider';
import { noWhitespaceValidator } from 'libs/shared/src/lib/service/helper.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { CookieService } from 'ngx-cookie-service';
import { CustomTrucksDataGridService } from '@piqet-angular/features';
@Component({
  selector: 'piqet-angular-new-custom-truck',
  templateUrl: './new-custom-truck.component.html',
  styleUrls: ['./new-custom-truck.component.scss'],
})
export class NewCustomTruckComponent implements OnDestroy {
  isMaximize = false;
  modalLabel: any;
  addNewCustomTruckForm!: FormGroup;
  finalSubmitted = false;
  truckList: any;
  refrigerationList: any;
  truckTypeId: any;
  newCustomTruckData: any;
  isFieldEmpty: any;
  refrigerationId: any;
  overLimitRefrigerationDuration: any;
  @Output() saveCustomTruckEvent = new EventEmitter<{ payload: any; pathName: any }>();
  overLimitEmptyReturns: any;
  overLimitMaxLoading: any;
  isRefrigerationDurationHrs: any;
  overLimitTareMass: any;
  isEnabled: any;
  activatedRoute: any;
  selectOrganization: any;
  organizationlist: any;
  setOrganizationValue: any;
  selectedDropDownValue: any;
  fromEdit: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  options: Options = {
    floor: 0,
    ceil: 100,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return value + '%';
        case LabelType.High:
          return value + '%';
        default:
          return value + '%';
      }
    },
  };
  showEdit: boolean = false;
  showCreate: boolean = false;
  showView: boolean = false;
  checkEntireAccess: boolean = false;
  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private customService: CustomService,
    private cookieService: CookieService,
    private customTrucksDataGridService: CustomTrucksDataGridService,
    public customFacade: CustomFacade,
    private sharedFacade: SharedFacade,
    private swalService: SwalService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.newCustomTruckData =
      this.modal?.modalService?.config?.initialState?.['newCustomTruckData'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.isDisabledDropDown = this.modalLabel == 'Review custom truck' ? true : false;
    this.isHideDropDown = this.activatedRoute == 'adminCustomTrucks' ? true : false;
    this.fromEdit = this.modal?.modalService?.config?.initialState?.['fromEdit'];
    this.truckList = this.newCustomTruckData.truckList;
    this.refrigerationList = this.newCustomTruckData.refrigerationItemList;
  }

  ngOnInit(): void {
    this.showEdit = this.customTrucksDataGridService.isAccess(this.activatedRoute, 'edit');
    this.showCreate = this.customTrucksDataGridService.isAccess(this.activatedRoute, 'create');
    this.showView = this.customTrucksDataGridService.isAccess(this.activatedRoute, 'view');
    this.checkEntireAccess =
      (this.showCreate && !this.fromEdit) ||
      (this.fromEdit && this.showEdit) ||
      (this.fromEdit && !this.showView);
    this.initializeData();
  }

  initializeData() {
    this.organizationlist = this.newCustomTruckData.organizationList;
    this.addNewCustomTruckForm = this.formBuilder.group({
      truckName: [this.newCustomTruckData.name || '', [Validators.required, noWhitespaceValidator]],
      selectTruck: [this.newCustomTruckData.projectTruckId || null, Validators.required],
      tareMass: [
        this.newCustomTruckData.tareMass || (0).toFixed(1),
        [Validators.min(0), Validators.max(100), Validators.required],
      ],
      maximumLoading: [
        this.newCustomTruckData.maxLoad || (0).toFixed(1),
        [Validators.min(0), Validators.max(100), Validators.required],
      ],
      loadInTruck: [this.newCustomTruckData.loadInTruck || (0).toFixed(1), Validators.required],
      percentLoaded: [
        { value: this.newCustomTruckData.persanteageMassLoad, disabled: true } || {
          value: null,
          disabled: true,
        },
      ],
      percentRural: [
        this.newCustomTruckData.persanteageRural || 0,
        [Validators.required, Validators.min(0), Validators.max(100), noWhitespaceValidator],
      ],
      percentRuralSlider: [this.newCustomTruckData.persanteageRural || 0],
      percentEmptyReturns: [
        this.newCustomTruckData.persanteageReturn || 100,
        [Validators.min(0), Validators.max(100), Validators.required],
      ],
      percentEmptyReturnsSlider: [this.newCustomTruckData.persanteageReturn || 100],
      refrigerationDuration: [
        this.newCustomTruckData.refrigerationDuration || (0).toFixed(1),
        [Validators.min(0), Validators.max(100), Validators.required],
      ],
      refrigerationType: [
        this.newCustomTruckData.refrigerationTruckId || { value: null, disabled: true },
        Validators.required,
      ],
    });
    this.organizatioListFunction();
    this.activatedRoute == 'adminCustomTrucks'
      ? this.addNewCustomTruckForm.addControl('organizationName', new FormControl())
      : '';
    this.setFormData();
    this.selectedDropDownValue = this.selectOrganization;
    this.setOrganizationValue = this.selectOrganization;
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  restrictE(event: any) {
    if (event.key === 'e' || event.key === 'E' || event.key === '-' || event.key === '+') {
      event.preventDefault();
    }
  }

  restrictSpecials(event: any) {
    if (
      event.key === 'e' ||
      event.key === 'E' ||
      event.key === '-' ||
      event.key === '+' ||
      event.key === '.'
    ) {
      event.preventDefault();
    }
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.newCustomTruckData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }

  setFormData() {
    this.addNewCustomTruckForm.patchValue({ organizationName: this.selectOrganization });
  }

  maxLoadOverLimit(event: any) {
    this.overLimitMaxLoading = event.target.value > 100 ? true : false;
  }

  tareMassOverLimit(event: any) {
    this.overLimitTareMass = event.target.value > 100 ? true : false;
  }

  changeEmptyReturnsValue(event: any) {
    this.addNewCustomTruckForm.controls['percentEmptyReturns'].setValue(event.value);
  }

  setEmptyReturnsPercentValue() {
    if (
      this.addNewCustomTruckForm.controls['percentEmptyReturns'].value >= 0 &&
      this.addNewCustomTruckForm.controls['percentEmptyReturns'].value <= 100
    ) {
      this.addNewCustomTruckForm.controls['percentEmptyReturnsSlider'].setValue(
        this.addNewCustomTruckForm.controls['percentEmptyReturns'].value
      );
    }
  }

  changeRuralValue(event: any) {
    this.addNewCustomTruckForm.controls['percentRural'].setValue(event.value);
  }

  setRuralPercentValue() {
    if (
      this.addNewCustomTruckForm.controls['percentRural'].value >= 0 &&
      this.addNewCustomTruckForm.controls['percentRural'].value <= 100
    ) {
      this.addNewCustomTruckForm.controls['percentRuralSlider'].setValue(
        this.addNewCustomTruckForm.controls['percentRural'].value
      );
    }
  }

  percentageCalc() {
    if (
      (!!this.addNewCustomTruckForm.controls['maximumLoading'].value &&
        !!this.addNewCustomTruckForm.controls['tareMass'].value) !== null &&
      this.addNewCustomTruckForm.controls['loadInTruck'].value !== ''
    ) {
      this.customService
        .truckPackageLoadCalculation(
          this.addNewCustomTruckForm.controls['tareMass'].value,
          this.addNewCustomTruckForm.controls['maximumLoading'].value,
          this.addNewCustomTruckForm.controls['loadInTruck'].value
        )
        .subscribe((res: any) => {
          if (res.message == '') {
            this.addNewCustomTruckForm.controls['percentLoaded'].setValue(
              res.data.persanteageMassLoad
            );
          }
          if (
            this.addNewCustomTruckForm.controls['loadInTruck'].value >
            this.addNewCustomTruckForm.controls['maximumLoading'].value
          ) {
            this.sharedFacade.warningToaster(
              'The suggested load is more than the capacity of the truck, so the truck load will be set to 100% capacity. Consider revising the load data.'
            );
            this.addNewCustomTruckForm.controls['loadInTruck'].setValue(
              this.addNewCustomTruckForm.controls['maximumLoading'].value
            );
            this.addNewCustomTruckForm.controls['percentLoaded'].setValue(100);
            if (
              this.addNewCustomTruckForm.controls['maximumLoading'].value &&
              this.addNewCustomTruckForm.controls['loadInTruck'].value == 0.0
            ) {
              this.addNewCustomTruckForm.controls['percentLoaded'].setValue(0);
            }
          }
        });
    }
  }

  alertConfirmation(data: any) {
    this.swalService
      .confirm(
        'Are you sure?',
        'Are you sure you want to change the organization? if you are change the organization than energy process data will be lost.',
        'organization'
      )
      .then(confirmed => {
        if (confirmed) {
          this.setOrganizationValue = data;
          this.selectedDropDownValue = data;
        } else {
          this.setOrganizationValue = this.selectedDropDownValue;
        }
      });
  }

  selectValue(event: any) {
    if (event.id && (event.name || event.keyCode != 13)) {
      this.alertConfirmation(event);
    }
  }

  selectedTruck(event: any) {
    if (!event.id) {
      return;
    }
    let maxLoad = event.maxLoad;
    let tareMass = event.tareMass;
    this.addNewCustomTruckForm.controls['maximumLoading'].setValue(maxLoad);
    this.addNewCustomTruckForm.controls['tareMass'].setValue(tareMass);
    this.truckTypeId = event.id;
    if (
      this.addNewCustomTruckForm.controls['maximumLoading'].value <
      this.addNewCustomTruckForm.controls['loadInTruck'].value
    ) {
      this.addNewCustomTruckForm.controls['loadInTruck'].setValue(
        this.addNewCustomTruckForm.controls['maximumLoading'].value
      );
      this.addNewCustomTruckForm.controls['percentLoaded'].setValue(100);
    }
    this.percentageCalc();
  }

  onSave() {
    this.finalSubmitted = true;
    if (
      this.activatedRoute == 'adminCustomTrucks' &&
      !this.addNewCustomTruckForm.controls['organizationName'].value?.name &&
      !this.addNewCustomTruckForm.controls['organizationName'].value
    ) {
      return;
    }
    if (this.addNewCustomTruckForm.valid) {
      const saveCustomTruckData = {
        projectTruckId: this.truckTypeId || this.newCustomTruckData.projectTruckId,
        tareMass: this.addNewCustomTruckForm.controls['tareMass'].value,
        maxLoad: this.addNewCustomTruckForm.controls['maximumLoading'].value,
        loadInTruck: this.addNewCustomTruckForm.controls['loadInTruck'].value,
        persanteageMassLoad: Number(this.addNewCustomTruckForm.controls['percentLoaded'].value),
        persanteageRural: this.addNewCustomTruckForm.controls['percentRural'].value,
        persanteageReturn: this.addNewCustomTruckForm.controls['percentEmptyReturns'].value,
        refrigerationDuration: this.addNewCustomTruckForm.controls['refrigerationDuration'].value,
        name: this.addNewCustomTruckForm.controls['truckName'].value.trimStart(),
        organizationId:
          this.addNewCustomTruckForm.controls['organizationName']?.value?.id ||
          this.newCustomTruckData?.organizationId ||
          Number(this.cookieService.get('organizationId')),
        refrigerationTruckId: this.addNewCustomTruckForm.controls['refrigerationType'].value,
        truckId: this.newCustomTruckData.truckId || 0,
        truckTypeId: this.truckTypeId || this.newCustomTruckData.projectTruckId,
      };
      this.saveCustomTruckEvent.emit({
        payload: saveCustomTruckData,
        pathName: this.activatedRoute,
      });
      this.modal.close();
    }
  }

  truckTypeInputSearch(term: string, item: any) {
    return item.truckType.toLowerCase().includes(term.toLowerCase());
  }

  refrigerationTypeInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  refrigerationBlur() {
    if (this.addNewCustomTruckForm.controls['refrigerationDuration'].value > 0) {
      this.addNewCustomTruckForm.controls['refrigerationType'].enable();
      this.isRefrigerationDurationHrs = true;
    } else {
      this.addNewCustomTruckForm.controls['refrigerationType'].disable();
      this.addNewCustomTruckForm.controls['refrigerationType'].setValue(null);
      this.isRefrigerationDurationHrs = false;
    }
  }

  changeRefrigeration(event: any) {
    if (event.id) {
      this.refrigerationId = event.id;
    }
  }

  ngOnDestroy() {
    this.customFacade.clearCustomTrucksData();
  }
}
